import {QuestionComponent} from './QuestionComponent'
import {Matrix} from 'app/models/questions/Matrix'
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms'
import {
  AudioRecorderComponent
} from "../../modules/survey/survey-viewer/survey-question/types/audio-recorder/audio-recorder.component";
import {Open} from "./Open";

export class AudioRecorder extends Open {

  getDisplayComponent() {
    return new QuestionComponent(AudioRecorderComponent, this)
  }

  buildStatementFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({})
    this.statementKeys.forEach(sKey => form.addControl(sKey, new UntypedFormControl(true, {})))
    return form
  }
}
